var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M500,990C230.5,990,10,769.5,10,500S230.5,10,500,10s490,220.5,490,490c0,85.8-24.5,165.4-61.3,238.9c-6.1,18.4-30.6,24.5-49,12.3c-18.4-6.1-24.5-30.6-12.3-49c36.8-61.3,55.1-134.8,55.1-202.1c0-232.8-189.9-416.5-416.5-416.5S89.6,273.4,89.6,500c0,232.8,189.9,416.5,416.5,416.5c73.5,0,147-18.4,208.3-55.1c18.4-12.3,36.8-6.1,49,12.3s6.1,36.8-12.3,49C671.5,965.5,585.8,990,500,990z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.9,536.8H500c-18.4,0-36.8-12.3-36.8-36.8V212.1c0-18.4,12.3-36.8,36.8-36.8c18.4,0,36.8,12.3,36.8,36.8v251.1h202.1c18.4,0,36.8,12.3,36.8,36.8C775.6,524.5,757.3,536.8,738.9,536.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.e5c9fd7af3023febb77463037c63fa7b.svg";
export { ForwardRef as ReactComponent };